import Api, { baseURL, requestOptionsGET, requestOptionsPUTWithBody } from '../api';
import newFetch from '../utils/newFetch';
import { UrlMaker } from '@/utils/urlParamsMaker';

const getShippersReceivableParams = (params, baseUrl) => {
  const { pageSize, pageNumber, senderId, hasReceipt, boardingNumber, numberCte, numberNfe } = params;

  const urlMaker = UrlMaker(baseUrl);

  urlMaker.addKeyAndString('PageNumber', pageNumber);
  urlMaker.addKeyAndString('PageSize', pageSize);
  urlMaker.addKeyAndString('SenderId', senderId);
  urlMaker.addKeyAndBoolean('HasReceipt', hasReceipt);
  urlMaker.addKeyAndArray('BoardingNumbers', boardingNumber);
  urlMaker.addKeyAndArray('CteNumbers', numberCte);
  urlMaker.addKeyAndArray('NfeNumbers', numberNfe);

  return urlMaker.getURL();
};

const getReceivableParams = (params, baseUrl) => {
  const { shipperId, hasReceipt, cargoId, deliveryId, boardingNumber, senderId, numberCte, numberNfe } = params;

  const urlMaker = UrlMaker(baseUrl);

  urlMaker.addKeyAndString('CargoId', cargoId);
  urlMaker.addKeyAndString('DeliveryId', deliveryId);
  urlMaker.addKeyAndString('ShipperId', shipperId);
  urlMaker.addKeyAndString('SenderId', senderId);
  urlMaker.addKeyAndBoolean('HasReceipt', hasReceipt);
  urlMaker.addKeyAndArray('BoardingNumbers', boardingNumber);
  urlMaker.addKeyAndArray('NfeNumbers', numberNfe);
  urlMaker.addKeyAndArray('CteNumbers', numberCte);

  return urlMaker.getURL();
};

const state = {};

const getters = {};

const mutations = {};

const actions = {
  fetchShippersWithoutInvoice(_, params = null) {
    return new Promise((resolve, reject) => {
      newFetch(
        baseURL + getShippersReceivableParams(params, Api.getSendersWithoutInvoice),
        requestOptionsGET(localStorage.getItem('accessToken'))
      )
        .then((res) => {
          res.data;
          resolve(res);
        })
        .catch((err) => reject(err));
    });
  },

  fetchCargosByShipperId(_, params = null) {
    return new Promise((resolve, reject) => {
      newFetch(
        baseURL + getReceivableParams(params, Api.getCargosWithoutInvoice),
        requestOptionsGET(localStorage.getItem('accessToken'))
      )
        .then((res) => {
          res.data;
          resolve(res);
        })
        .catch((err) => reject(err));
    });
  },

  fetchAllDeliveriesByCargoId(_, params = null) {
    return new Promise((resolve, reject) => {
      newFetch(
        baseURL + getReceivableParams(params, Api.getAllDeliveriesWithoutInvoiceByCargo),
        requestOptionsGET(localStorage.getItem('accessToken'))
      )
        .then((res) => {
          res.data;
          resolve(res);
        })
        .catch((err) => reject(err));
    });
  },

  fetchDeliveriesByCargoId(_, params = null) {
    return new Promise((resolve, reject) => {
      newFetch(
        baseURL + getReceivableParams(params, Api.getDeliveriesWithoutInvoiceByCargo),
        requestOptionsGET(localStorage.getItem('accessToken'))
      )
        .then((res) => {
          res.data;
          resolve(res);
        })
        .catch((err) => reject(err));
    });
  },

  fetchNfesByDeliveryId(_, params = null) {
    return new Promise((resolve, reject) => {
      newFetch(
        baseURL + getReceivableParams(params, Api.getNfesWithoutInvoice),
        requestOptionsGET(localStorage.getItem('accessToken'))
      )
        .then((res) => {
          res.data;
          resolve(res);
        })
        .catch((err) => reject(err));
    });
  },

  getDeliveriesWithoutInvoicesByShipperId(_, params) {
    return new Promise((resolve, reject) => {
      newFetch(
        baseURL + getReceivableParams(params, Api.getDeliveriesWithoutInvoicesByShipperId),
        requestOptionsGET(localStorage.getItem('accessToken'))
      )
        .then((res) => {
          res.data;
          resolve(res);
        })
        .catch((err) => reject(err));
    });
  },

  getAllDeliveriesWithoutInvoicesByShipperId(_, id) {
    return new Promise((resolve, reject) => {
      newFetch(
        baseURL + Api.getAllDeliveriesWithoutInvoicesByShipperId + id,
        requestOptionsGET(localStorage.getItem('accessToken'))
      )
        .then((res) => {
          res.data;
          resolve(res);
        })
        .catch((err) => reject(err));
    });
  },

  getRelatedAditionalsReceivableByShipperId(_, id) {
    return new Promise((resolve, reject) => {
      newFetch(
        baseURL + Api.getRelatedAditionalsReceivableByShipper + id,
        requestOptionsGET(localStorage.getItem('accessToken'))
      )
        .then((res) => {
          res.data;
          resolve(res);
        })
        .catch((err) => reject(err));
    });
  },

  updateObservationDelivery(_, payload) {
    return new Promise((resolve, reject) => {
      newFetch(
        baseURL + Api.updateObservationCte,
        requestOptionsPUTWithBody(localStorage.getItem('accessToken'), payload)
      )
        .then((res) => {
          res.data;
          resolve(res);
        })
        .catch((err) => reject(err));
    });
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
